
export const initDialogData = {
  FName: "",
  LName: "",
  NName: "",
  Email: "",
  Tel: "",
  AccSts: 1,
  SendEmail: 1,
}